import { Check, Link } from "@phosphor-icons/react";

import { useClipboard } from "~/hooks/clipboard";
import { useLocale } from "~/hooks/locale";

export const CopyLink: React.FC<{ path: string }> = ({ path }) => {
  const { t } = useLocale();
  const { copy, didCopy } = useClipboard();
  const Icon = didCopy ? Check : Link;
  return (
    <button
      onClick={() => {
        copy(window.location.origin + path);
      }}
    >
      <Icon weight="bold" className="size-4" />
      {didCopy ? t("copied") : t("copy_link")}
    </button>
  );
};
